const Tabs = {
  variants: {
    menu: {
      tab: {
        fontWeight: 'bold',
        boxShadow: 'md',
        marginRight: '10px',
        borderWidth: '1px',
        padding: '8px 32px',
        backgroundColor: 'brand.white',
        borderRadius: 'md',
        _selected: {
          color: 'brand.white',
          backgroundColor: 'brand.primary',
        },
        _focus: {ring: 'none'},
      },
    },
  },
}

export default Tabs
